import HeaderImage from "../../assets/images/main_header.jpg";
import {Breadcrumb, Button, Image, Table} from "antd";
import {Link} from "react-router-dom";
import {FilePdfOutlined} from "@ant-design/icons";

import Image1 from "../../assets/images/factory4.jpg";
import Image2 from "../../assets/images/factory3.jpg";
import TY109110002File from "../../assets/files/TY 10.91.10-002.pdf";

const MMGP = () => {

    const images = [
        { id: 1, src: Image1, alt: "МТП-1 вид 1" },
        { id: 2, src: Image2, alt: "МТП-1 вид 2" },
    ];

    const tableData = [
        { key: "1", number: 1, indicator: "Массовая доля влаги", value: "не более 10%" },
        {
            key: "2",
            number: 2,
            indicator: "Суммарная доля углекислого кальция и углекислого магния в пересчете на углекислый кальций",
            value: "не менее 85%"
        },
        {
            key: "3",
            number: 3, indicator: "Массовая доля кальция",
            value: "Не менее 32%"
        },
        {
            key: "4",
            number: 4, indicator: "Массовая доля веществ, не растворимых в HC1",
            value: "Не более 5%"
        },
        {
            key: "5",
            number: 5, indicator: "Массовая доля невредных примесей (окисей железа и аллюминия, углекислого магния)",
            value: "Не более 8%"
        },
        {
            key: "6",
            number: 6, indicator: "Массовая доля металломагнитных примесей размером до 2 мм включительно в 1 кг продукта",
            value: "Не более 30мг"
        },
        {
            key: "7",
            number: 7, indicator: "Наличие металлических частиц с острыми краями размером не более 2 мм",
            value: "Не допускается"
        },
        {
            key: "8",
            number: 8, indicator: "Гранулометрический состав (остаток на сите №2)",
            value: "Не более 10%"
        },
        {
            key: "9",
            number: 9, indicator: "Токсичные элементы, пестициды, удельная эффективная активность естественных радионуклидов (Cs-137, Sr-90)",
            value: "В соответствии с требованием Главветуправления РФ"
        },
    ];

    const tableColumns = [
        {
            title: "№",
            dataIndex: "number",
            key: "number",
            width: 80,
            align: "center",
        },
        {
            title: "Показатели",
            dataIndex: "indicator",
            key: "indicator",
            width: "65%",
        },
        {
            title: "Численные значения, нормированные по ТУ",
            dataIndex: "value",
            key: "value",
        },
    ];

    return(
        <div className={"product-container"}>
            <div className={"product-container-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className={"product-header"}>
                <h1>ММЖП</h1>
                <Breadcrumb className="product-header-breadcrumb"
                            items={[
                                {
                                    title: <Link to="/">Главная страница</Link>
                                },
                                {
                                    title: <Link to="/productions">Продукция</Link>
                                },
                                {
                                    title: <span>ММЖП</span>,
                                },
                            ]}
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"product-content"}>
                <div className={"product-content-image-column"}>
                    <Button
                        type="primary"
                        icon={<FilePdfOutlined/>}
                        size="large"
                        onClick={() => window.open(TY109110002File, "_blank", "noopener,noreferrer")}
                        className="pp-pdf-button"
                    >
                        Посмотреть ТУ
                    </Button>

                    <div className="images-grid">
                        {images.map((image) => (
                            <div className="image-wrapper" key={image.id}>
                                <Image
                                    src={image.src}
                                    alt={image.alt}
                                    className="pp-image"
                                    preview={{
                                        src: image.src,
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                </div>


                <div className={"product-content-text-column"}>
                    <div className={"product-content-text-column"}>
                        <div className={"product-content-description"}>
                            <h2>Описание продукта</h2>
                            <p>
                                <strong>ММЖП</strong> — это кормовой мел, специально предназначенный для производства
                                комбикормов и минеральной подкормки сельскохозяйственных животных и птиц. Продукт
                                представляет собой измельченный порошок и выступает в качестве экологически чистой
                                кормовой добавки для обогащения рациона животных и птиц кальцием
                            </p>

                            <h3>Основные характеристики:</h3>
                            <ul>
                                <li>
                                    Высокое содержание кальция: Массовая доля углекислого кальция и магния, являющихся
                                    источником кальция, составляет не менее 88%
                                </li>

                                <li>
                                    Низкое содержание вредных примесей: Строго нормируется содержание токсичных
                                    элементов (свинец, кадмий, ртуть) и металломагнитных частиц.
                                </li>

                                <li>
                                    Безопасность: Радиационная безопасность подтверждается (удельная эффективная
                                    активность естественных радионуклидов не более 370 Бк/кг). Продукт нетоксичен
                                    для животных и птиц, но требует стандартных мер предосторожности при работе с пылью.
                                </li>
                            </ul>

                            <h3>Области применения:</h3>
                            <ul>
                                <li>
                                    Сельское хозяйство и животноводство: Производство комбикормов и минеральных
                                    подкормок для всех видов сельскохозяйственных животных (крупный рогатый скот, свиньи)
                                    и птицы (куры, индейки, перепела)
                                </li>
                                <li>
                                    Ветеринария: Используется для профилактики и коррекции заболеваний, связанных с
                                    дефицитом кальция (остеопороз, остеомаляция, проблемы с яичной скорлупой)
                                </li>
                                <li>
                                    Другие отрасли: В отдельных случаях может применяться в производстве стекла, керамики, линолеума
                                </li>
                            </ul>

                            <h3>Преимущества как кормовой добавки:</h3>
                            <ul>
                                <li>
                                    Укрепление здоровья: Способствует правильному формированию и укреплению костной
                                    ткани, мышечной массы, улучшает качество яичной скорлупы
                                </li>
                                <li>
                                    Повышение продуктивности: Улучшает обмен веществ, способствует получению здорового
                                    потомства и повышению общей продуктивности животных
                                </li>
                                <li>
                                    Натуральность и усвояемость: Экологически чистый продукт без химических добавок.
                                    Мелкий помол обеспечивает высокую усвояемость кальция организмом
                                </li>
                                <li>
                                    Экономическая эффективность: Доступная и недорогая добавка, позволяющая
                                    оптимизировать рацион и снизить риски заболеваний
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MMGP;